import {
  AfterViewInit,
  ApplicationRef,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import {
  Form,
  Field,
  Layout,
} from '../../../domain/form.interface';
import { Template } from '../../../domain/template.interface';
import { Pagination } from '../../../domain/pagination.interface';
import { Subject, filter, switchMap, take, takeUntil, tap } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { ConfirmationDialogData, ModalConfirmationComponent } from '../../commons/modal-confirmation/modal-confirmation.component';
import { NgClass } from '@angular/common';
import Sortable from 'sortablejs';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { setSelectedForm } from '../../../infrastructure/store/selectors/form.selector';
import { setSelectedVersion } from '../../../infrastructure/store/selectors/version.selector';
import { setSelectedTemplate } from '../../../infrastructure/store/selectors/template.selector';
import { editForm } from '../../../infrastructure/store/actions/form.actions';
import { editVersion } from '../../../infrastructure/store/actions/version.actions';
import { selectConfig } from '../../../infrastructure/store/selectors/config.selector';

@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.scss']
})
export class TemplateComponent {
  unsubscribe$ = new Subject();

  formOptions = {}; // Fill web component input

  elementSelected!: Form; // Element selected to toggle form-version
  forms: Form[] = []; // Forms lis
  formSelected!: Form; // Form selected
  versions: Form[] = [];
  versionSelected!: Form; // Version selected
  templates: Template[] = []; // Templates list
  templateSelected: Template; // Template selected
  fields: Field[] = [];
  layout: Layout[] = [];
  editedLayout: Layout[] = [];
  currentPage;
  currentPagePos;
  search: string = '';
  isPreview = false;
  paramsValue;
  changeDetected = false;
  urlBackend: string = "";

  constructor(
    private store: Store,
    private _renderer: Renderer2,
    private _element: ElementRef,
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.store.select(selectConfig).pipe(
      filter(x => x.data['FORM_API']),
			take(1)   
    ).subscribe({
      next: (v) => {          
        if(v) {
          this.urlBackend = v.data['FORM_API'];
        }
      },
      error: (e) => {         
        console.log('ERROR->', <any>e);
      }
    });

    this.store
      .pipe(select(setSelectedForm))
      .pipe(
        //filter(x => x.status == "success"),
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: (v) => {          
          this.formSelected = v;
          if(v) {
            this.isPreview = false;
            this.elementSelected = v;
            this.fields = [...v.fields];         
            this.layout = [...v.layout];
            this.editedLayout = [...v.layout];
            if(this.layout.length > 0) {
              this.currentPage = this.layout[0];
              this.currentPagePos = 0;              
            } else {
              this.currentPage = null;
              this.currentPagePos = null;
            }
            console.log('::::fields->', this.fields)
            console.log('::::layout->', this.layout)
            console.log('::::editedLayout->', this.editedLayout)
            console.log('::::currentPage->', this.currentPage)            
          }
        },
        error: (e) => {         
          console.log('ERROR->', <any>e);
        }
      });

    this.store
      .pipe(select(setSelectedVersion))
      .pipe(
        //filter(x => x.status == "success"),
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: (v) => {
          this.versionSelected = v;
          if(v) {
            this.isPreview = false;
            this.elementSelected = v;
            this.fields = [...v.fields];         
            this.layout = [...v.layout];
            this.editedLayout = [...v.layout];
            if(this.layout.length > 0) {
              this.currentPage = this.layout[0];
              this.currentPagePos = 0;              
            } else {
              this.currentPage = null;
              this.currentPagePos = null;
            }
            console.log('::::fields->', this.fields)
            console.log('::::layout->', this.layout)
            console.log('::::editedLayout->', this.editedLayout)
            console.log('::::currentPage->', this.currentPage)           
          }        
        },
        error: (e) => {         
          console.log('ERROR->', <any>e);
        }
      });

      this.store
      .pipe(select(setSelectedTemplate))
      .pipe(
        //filter(x => x.status == "success"),
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: (v) => {
          this.templateSelected = v;
          if(v) {
              this.previewLayout();      
          }        
        },
        error: (e) => {         
          console.log('ERROR->', <any>e);
        }
      });   

  }

  previewLayout() {
    console.log('Preview'); 
    this.setFormOptions(!this.isPreview);   
    this.isPreview = !this.isPreview;    
  }

  setFormOptions(preview: boolean) {
    this.formOptions = {
      formId: this.formSelected?.sk,
      versionId: this.elementSelected.pk == 'version' ? this.versionSelected?.sk : '',
      page: this.currentPagePos + 1,
      isPreview: preview,
      urlBackend: this.urlBackend,
      form: {
        ...this.elementSelected,
        layout: this.editedLayout,
      }
    }
  }

  searchTemplates(search: string) {
    this.search = search;
  }

  setCurrentPage(id, index) {
    this.currentPagePos = index;
    let page = this.editedLayout.filter((obj, index) => {
      return obj.id === id.toString();
    });
    this.currentPage = page[0];
    // Refresh preview input
    this.setFormOptions(this.isPreview);  
  }

  addTemplate() {}

}
